import { connectSocket, socketManager } from "./chat";
import { isConfigLoaded, isOpen, openWidget, toggleWidget } from "./widget";

isConfigLoaded.subscribe((isConfigLoaded) => {
  if (isConfigLoaded && !socketManager.get()) {
    connectSocket();
  }
});

export { openWidget, toggleWidget };
